
/************************************ Knee_locator *************************************************/

VALID_CURVE = ["convex", "concave"]
VALID_DIRECTION = ["increasing", "decreasing"]

class KneeLocator{



	constructor(x, y, curve, direction)
	{
		this.x = x;
        this.y = y;
        this.S = 1.0; // this was set by default 
        this.curve = curve;
        this.direction = direction;
        this.N = x.length;
        this.all_knees = new Set();
        this.all_norm_knees = new Set();
        this.all_knees_y = [];
        this.all_norm_knees_y = [];
        this.knee;
        this.norm_knee; 
        this.y_at_knee; 
        this.online = false; 
        this.check_arguements(this.curve,this.direction)
        
        
	}

    
/****************************************************************************/

	find_Knee()
	{
		// step 1: fit an spline (i think it's not necessary but we can check it later)
		// step 2: normalize x and y 
		var y_normalized = KneeLocator.normalize(this.y)
		var x_normalized = KneeLocator.normalize(this.x)

		// step 3: calculate the difference curve 
		y_normalized = KneeLocator.transfrom_y(y_normalized,this.direction,this.curve)
		var y_difference = []
		for (var i=0; i<y_normalized.length; i++)
		{
		  y_difference[i] = y_normalized[i] - x_normalized[i]
		}
		var x_difference = [...x_normalized]

		// step 4: identify local maxima and local minima  ==> needs to be checked later :p
		
		var maxima_indices = KneeLocator.local_maxima(y_difference)
		var minima_indices = KneeLocator.local_minima(y_difference)
		

		// step5 : calculate thresholds

		var diffs = KneeLocator.diff(x_normalized)
		var diffs_mean =KneeLocator.average(diffs)
		
		var Tmx = []
		for (var i=0; i< maxima_indices.length; i++)
		{
		 Tmx[i] = y_difference[maxima_indices[i]] - this.S*Math.abs(diffs_mean)
		}    

		
		// step 6 : find the knee point 
		
		// check if there are no local maximas
		if(maxima_indices.length ==0)
		{
			//fx.log.info("something must be wrong there's no local maximas")
			return []; 
			// return None 
		}
		
		var maxima_threshold_index = 0;
		var minima_threshold_index = 0;
        var j = 0; 
        //  declare these variables here to null cos i don't know how else i would intialize them to 
        var threshold ;
		var knee; 
		var threshold_index ; 
		var norm_knee ;  var y_at_knee ; 
		for (var i=0; i < x_difference.length; i++)
		{
			

			//skip points on the curve before the the first local maxima
			if (i < maxima_indices[0])
			{
				continue 
			}
            j = i + 1; 
            //reached the end of the curve
            if(x_difference[i]==1.0)
            {
            	break; 
            }
            if(maxima_indices.includes(i))
			{
            	threshold = Tmx[maxima_threshold_index]; 
            	threshold_index = i;
            	maxima_threshold_index ++; 
            }
            if(minima_indices.includes(i))
            {
            	threshold = 0.0;
            	minima_threshold_index++;
            }


            if(y_difference[j] < threshold)
            {   

            	if (this.curve =="convex")
            	{

            		if(this.direction=="decreasing")
            		{
            			
            			knee = this.x[threshold_index];
            			norm_knee = x_normalized[threshold_index];
            		}
            		else
            		{
            			
            			knee = this.x[this.x.length-(threshold_index+1)];
            			norm_knee = x_normalized[threshold_index];
            		}
            	}
            	else if (this.curve =="concave")
            	{
  					if(this.direction =="decreasing")
  					{
  						knee = this.x[this.x.length -(threshold_index + 1)];
  						norm_knee = x_normalized[threshold_index];
  					}
  					else 
  					{
  						knee = this.x[threshold_index];
  						norm_knee = x_normalized[threshold_index];
  					}
            	}
            	// add the y value at the knee 
            
            	if ((this.all_knees).has(knee) == false) 
            	{
                   this.all_knees_y.push(this.y[this.x.indexOf(knee)])
                   this.all_norm_knees_y.push(y_normalized[this.x.indexOf(norm_knee)])
            	}
            	this.all_knees.add(knee);
            	this.all_norm_knees.add(knee); 

            	// return the first knee point 
            	if(this.online == false)
            	{
            		this.knee = knee;
					this.knee_norm = norm_knee
					this.y_at_knee = this.y[this.x.indexOf(knee)]
					return [this.knee, this.y_at_knee]

            	}
            }

		}

        // no elbow/knee points were found 
		if(this.all_knees.size==0)
		{
			// return an empty array 
			return [];
		}
		else {
			this.knee = knee;
			this.knee_norm = norm_knee
			this.y_at_knee = this.y[this.x.indexOf(knee)]
			return [this.knee, this.y_at_knee]
		}


	}

	// check that curve and direction are valid arguements 
	check_arguements(curve, direction)
	{
		var valid_curve = VALID_CURVE.includes(this.curve);
        var valid_direction = VALID_DIRECTION.includes(this.direction);
        if (!valid_curve || !valid_direction)
        {
       	// here i should raise an error 
       	//console.log("Please check that the curve and direction arguments are valid.")
		   fx.log.error("Please check that the curve and direction arguments are valid.");

        }
	}


// compute the average of a set of numbers 
	static  average(nums) {
	    return nums.reduce((a, b) => (a + b)) / nums.length;
	}
    
    // normalize the values of an array between 0 and 1 
	static normalize(a)
	{
		var max_value = Math.max(...a);
	 	var min_value = Math.min(...a);
		var normalized_arr = []
		for (var i=0; i<a.length; i++)
		{
			normalized_arr[i] = (a[i] - min_value)/(max_value-min_value);
		}
		return normalized_arr;

	}

    // find the indices of local maximas as implemented in library the writer uses greater_equal/less_euqual comparator and 
    // he also adds both ends so we'll do so :p 
	static  local_maxima(arr) 
	{
	   var indices = [];

	   if(arr[0]>=arr[1])
	    {
           indices.push(0)
	    }

	   for (var i = 1; i < arr.length - 1; ++i) {
	        if (arr[i-1] <= arr[i] && arr[i] >= arr[i+1])
	         {
	         	indices.push(i)
	         }
	    }
	    // add the ends if ther're and extremas 
	    
	    if(arr[arr.length-1]>=arr[arr.length-2])
	    {
	    	indices.push(arr.length-1)
	    }
	return indices 
	}

	// a function that returns inidces of local minimas 
	static local_minima(arr)
	{
		var indices = [];

		if(arr[0]<=arr[1])
	    {
           indices.push(0);
	    }
	   
	   for (var i = 1; i < arr.length - 1; ++i) {
	        if (arr[i-1] >= arr[i] && arr[i] <= arr[i+1])
	         {
	         	indices.push(i)
	         }
	    }
        
	    if(arr[arr.length-1]<=arr[arr.length-2])
	    {
	    	indices.push(arr.length-1);
	    }
	return indices 
	}

	// the diff function of the numpy library 
    static diff(arr)
    {
	    var diff = []
		for(var i=0; i < arr.length -1; i++)
		{
			diff[i] = Math.abs(arr[i+1] - arr[i])
		}
		return diff 
    }

    static transfrom_y(y, direction, curve)
    {   var maximum = Math.max(...y)
    	if(direction == "decreasing")
    	{
    		if (curve == "concave")
    		{	y.reverse();
    		}
    		else if(curve == "convex")
    		{   
    			for (var i=0; i < y.length; i++)
    			{
    				y[i] =  maximum - y[i];
    			}
    		}
    	}
    	else if (direction == "increasing" & curve =="convex")
    	{
    		for (var i =0; i < y.length; i++)
    		{
    			y[i] = maximum - y[i];
    		}
    		y.reverse();
    	}

    	return y; 
    }

}

/***************************************************************************************************/
